import React, { useState, useEffect } from "react";
import axios from "axios";

const UpcomingAssignments = ({ platformUrl }) => {
    const [assignments, setAssignments] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const token = params.get("token");
        const uuid = params.get("uuid");

        if (!token || !uuid) {
            setError("Missing access token or UUID. Please log in.");
            return;
        }

        const fetchUpcomingAssignments = async () => {
            try {
                // Step 1: Get the user ID using the UUID
                const userResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v1/users/uuid:${uuid}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const userId = userResponse.data.id;

                // Step 2: Get the current date and calculate the date for one week ahead
                const currentDate = new Date().toISOString();
                const nextWeekDate = new Date();
                nextWeekDate.setDate(nextWeekDate.getDate() + 7);
                const oneWeekAheadDate = nextWeekDate.toISOString();

                // Step 3: Fetch upcoming assignments (calendar events) for the user
                const assignmentsResponse = await axios.get(
                    `${platformUrl}/learn/api/public/v1/calendars/items?start=${currentDate}&end=${oneWeekAheadDate}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                // Filter assignments for type "Assignment"
                const upcomingAssignments = assignmentsResponse.data.results.filter(
                    (event) => event.type === "GradebookColumn"
                );

                setAssignments(upcomingAssignments);
            } catch (err) {
                setError(err.message);
            }
        };

        fetchUpcomingAssignments();
    }, []);

    if (error) {
        return (
            <div className="bb-error">
                <h1>Error</h1>
                <p>{error}</p>
            </div>
        );
    }

    return (
        <div className="assignments-container">
            <h1>Upcoming Assignments (Next 7 Days)</h1>
            {assignments.length === 0 ? (
                <p>No assignments due in the next week.</p>
            ) : (
                <table className="bb-table">
                    <thead>
                    <tr>
                        <th>Title</th>
                        <th>Course Name</th>
                        <th>Due Date</th>
                        <th>Description</th>
                        <th>Time Left</th>
                    </tr>
                    </thead>
                    <tbody>
                        {assignments.map((assignment) => (
                            <AssignmentRow key={assignment.id} assignment={assignment} />
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

const AssignmentRow = ({ assignment }) => {
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft(assignment.end));

    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft(assignment.end));
        }, 1000);

        return () => clearInterval(interval);
    }, [assignment.end]);

    return (
        <tr>
            <td>{assignment.title}</td>
            <td>{assignment.calendarName || "N/A"}</td>
            <td>{new Date(assignment.end).toLocaleString()}</td>
            <td>{assignment.description || "No description available"}</td>
            <td>
                {timeLeft.minutes >= 0 && timeLeft.seconds >= 0
                    ? `${timeLeft.minutes}m ${timeLeft.seconds}s`
                    : "Time's up!"}
            </td>
        </tr>
    );
};

const calculateTimeLeft = (end) => {
    const now = new Date();
    const dueDate = new Date(end);
    const difference = dueDate - now;

    return difference > 0
        ? {
              minutes: Math.floor((difference / 1000 / 60) % 60),
              seconds: Math.floor((difference / 1000) % 60),
          }
        : { minutes: 0, seconds: 0 };
};

export default UpcomingAssignments;

